import { mutator } from 'satcheljs';
import { onLayoutChanged } from '../actions';
import { getAppStore } from '../store/store';

mutator(onLayoutChanged, msg => {
  getAppStore().layout = msg.layout;
});
